import { render } from "./file.upload.vue?vue&type=template&id=06919d67"
import script from "./file.upload.vue?vue&type=script&lang=js"
export * from "./file.upload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\安可控\\Dtsc.Official.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__